import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter, useNavigate, useLocation } from 'react-router-dom';
import Navigation from './components/ui/navigation';
import Footer from './components/ui/footer';
import HeroSection from './components/hero-section';
import ServicesSection from './components/services-section';
import ShowroomSection from './components/showroom-section';
import AboutSection from './components/about-section';
import ContactSection from './components/contact-section';
import ClientsSection from './components/clients-section';
import Legal from './pages/legal';
import NotFound from './pages/notfound';
import { X } from 'lucide-react';
import { Button } from './components/ui/button';
import CookieBanner from './components/ui/cookie-banner';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Preload critical images
const preloadImages = () => {
  const imagesToPreload = [
    '/src/assets/Logo_310x150_trans.svg',
    '/src/assets/herosection/1_PV.jpeg'
  ];
  
  imagesToPreload.forEach(src => {
    const img = new Image();
    img.src = src;
  });
};

function HomePage() {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <ShowroomSection />
      <AboutSection />
      <ClientsSection />
      <ContactSection />
    </>
  );
}

function LegalModal() {
  const navigate = useNavigate();
  
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-4 top-4"
          onClick={() => navigate('/')}
        >
          <X className="h-6 w-6" />
        </Button>
        <Legal />
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    // Preload critical images when the app mounts
    preloadImages();
    
    // Ensure we start at the top of the page on initial load and refresh
    window.scrollTo(0, 0);
    
    // Add scroll to top on page refresh
    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <Navigation />
      
      <main className="flex-grow pt-[144px]"> {/* Added padding top to account for fixed header */}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/legal" element={<LegalModal />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      
      <Footer />
      <CookieBanner />
    </div>
  );
}

export default App;
